<template>
	<div>
		<v-section-header specialClass="has-image d-none d-lg-block" backgroundImg="images/landing/home-bg.jpg" backgroundVideo="/videos/home-bg.mp4" >
		<!-- <v-section-header specialClass="has-image d-none d-lg-block" :backgroundImg="this.video.img" :backgroundVideo="this.video.url"> -->
			<b-col cols="12">
				<h1 class="text-center text-white" style="margin-top: 35vh;">Nº 1 EN COMPRA Y VENTA ONLINE <br /> DE AUTOS Y PROPIEDADES <br /> EN CHILE </h1>
			</b-col>
			<div class="w-100 header-buttons">
				<b-row no-gutters class="mt-5">
					<b-col class="text-center text-white">
						<div class="lead mb-2">AUTOS</div>
						<b-button size="lg" class="px-5" variant="outline-light" to="/autos">Entrar</b-button>
					</b-col>
					<b-col class="text-center text-white">
						<div class="lead mb-2">PROPIEDADES</div>
						<b-button size="lg" class="px-5" variant="outline-light" href="https://www.macal.cl/Propiedades/Busqueda">Entrar</b-button>
					</b-col>
				</b-row>
			</div>
			<div class="scrolldown-btn" @click="scrollFromHead" style="bottom: 100px;">
				<svg version="1.1" id="arrows" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="50px" height="80px" viewbox="0 0 50 80" enable-background="new 0 0 50 80" xml:space="preserve">
					<path class="first-path" fill="#FFFFFF" d="M24.752,79.182c-0.397,0-0.752-0.154-1.06-0.463L2.207,57.234c-0.306-0.305-0.458-0.656-0.458-1.057                  s0.152-0.752,0.458-1.059l2.305-2.305c0.309-0.309,0.663-0.461,1.06-0.461c0.398,0,0.752,0.152,1.061,0.461l18.119,18.119                  l18.122-18.119c0.306-0.309,0.657-0.461,1.057-0.461c0.402,0,0.753,0.152,1.059,0.461l2.306,2.305                  c0.308,0.307,0.461,0.658,0.461,1.059s-0.153,0.752-0.461,1.057L25.813,78.719C25.504,79.027,25.15,79.182,24.752,79.182z"></path>
					<path class="second-path" fill="#FFFFFF" d="M24.752,58.25c-0.397,0-0.752-0.154-1.06-0.463L2.207,36.303c-0.306-0.304-0.458-0.655-0.458-1.057                  c0-0.4,0.152-0.752,0.458-1.058l2.305-2.305c0.309-0.308,0.663-0.461,1.06-0.461c0.398,0,0.752,0.153,1.061,0.461l18.119,18.12                  l18.122-18.12c0.306-0.308,0.657-0.461,1.057-0.461c0.402,0,0.753,0.153,1.059,0.461l2.306,2.305                  c0.308,0.306,0.461,0.657,0.461,1.058c0,0.401-0.153,0.753-0.461,1.057L25.813,57.787C25.504,58.096,25.15,58.25,24.752,58.25z"></path>
				</svg>
			</div>
		</v-section-header>
		<v-section-header fullscreen="" specialClass="has-image d-lg-none pb-5 mobile" backgroundImg="images/landing/home-bg.jpg">
			<b-col>
				<h1 class="section-header text-center text-white mt-4" >Nº 1 EN COMPRA Y VENTA ONLINE <br /> DE AUTOS Y PROPIEDADES <br /> EN CHILE</h1>
				<b-row no-gutters>
					<b-col class="text-center text-white">
						<div class="mb-2"><b>AUTOS</b></div>
						<b-button class="px-5" variant="outline-light" to="/autos">Entrar</b-button>
					</b-col>
					<b-col class="text-center text-white">
						<div class="mb-2"><b>PROPIEDADES</b></div>
						<b-button class="px-5" variant="outline-light" href="https://www.macal.cl/Propiedades/Busqueda">Entrar</b-button>
					</b-col>
				</b-row>
			</b-col>
		</v-section-header>
		<b-container fluid>
			<v-section-white specialClass="scroll-receiver">
				<b-row class="my-5">
					<b-col md="4" offset-md="1" class="pl-0 d-none d-md-block">
						<div class="d-table h-100 w-100">
							<div class="d-table-cell align-middle w-100 h-100">
								<b-img src="images/landing/pasos_1.svg" fluid ></b-img>
							</div>
						</div>
					</b-col>
					<b-col md="6">
						<div class="d-table h-100 w-100">
							<div class="d-table-cell align-middle w-100 h-100 text-center">
								<h2 class="pt-5 inline-block"><div class="step-number-macal">1</div></h2>
								<h3 class="section-subheader"><b>COMPRAR UN AUTO O PROPIEDAD, IGUAL DE FÁCIL</b></h3>
								<h4 class="mb-4 text-justify">De manera simple puedes participar de un remate</h4>
								<p class="mt-3 text-justify">
									Busca tu auto o propiedad, inscríbete en el remate y participa. Así de fácil puedes comprar en Macal.
								</p>
							</div>
						</div>
					</b-col>
				</b-row>
			</v-section-white>
			<v-section-grey>
				<b-row class="my-5">
					<b-col md="6" offset-md="1">
						<div class="d-table h-100 w-100">
							<div class="d-table-cell align-middle w-100 h-100 text-center">
								<h2 class="pt-5 inline-block"><div class="step-number-macal">2</div></h2>
								<h3 class="section-subheader"><b>VENDE FÁCIL, VENDE RÁPIDO</b></h3>
								<h4 class="mb-4 text-justify">Auto o casa, te ayudamos a venderlo más fácil que en cualquier otra parte</h4>
								<b-tabs content-class="mt-3" class="macal-tabs" justified >
									<b-tab title="Autos" active>
										<p class="mt-3 text-justify">Cotiza tu auto, agenda el día y hora en el punto de entrega que te acomode y tu auto se ofrecerá en el próximo remate.</p>
									</b-tab>
									<b-tab title="Propiedades">
										<p class="mt-3 text-justify">Completa los datos de tu propiedad en nuestro formulario online. Un ejecutivo de Macal te contactará para ofrecerte una propuesta de venta y si estás de acuerdo con esta, tu propiedad se ofrecerá en el próximo remate.</p>
									</b-tab>
								</b-tabs>
							</div>
						</div>
					</b-col>
					<b-col md="4" class="pr-0 d-none d-md-block">
						<div class="d-table h-100 w-100">
							<div class="d-table-cell align-middle w-100 h-100">
								<b-img src="images/landing/pasos_2.svg" fluid ></b-img>
							</div>
						</div>
					</b-col>
				</b-row>
			</v-section-grey>
			<v-section-white>
				<b-row class="my-5">
					<b-col md="4" offset-md="1" class="pl-0 d-none d-md-block">
						<div class="d-table h-100 w-100">
							<div class="d-table-cell align-middle w-100 h-100">
								<b-img src="images/landing/pasos_3.svg" fluid ></b-img>
							</div>
						</div>
					</b-col>
					<b-col md="6">
						<div class="d-table h-100 w-100">
							<div class="d-table-cell align-middle w-100 h-100 text-center">
								<h2 class="pt-5 inline-block"><div class="step-number-macal">3</div></h2>
								<h3 class="section-subheader"><b>PARTICIPA ONLINE EN MACAL.CL</b></h3>
								<h4 class="mb-4 text-center">Conéctate con tu cuenta de usuario Macal el día del remate y haz tu oferta en el auto o propiedad de tu interés. Si tu oferta es la más alta, eres el ganador!.</h4>
							</div>
						</div>
					</b-col>
				</b-row>
			</v-section-white>
			<v-section-grey>
				<b-row class="my-5">
					<b-col class="text-center">
						<h2 class="pt-5"><b>DESCUBRE LOS BENEFICIOS DE <br />TENER TU USUARIO MACAL</b></h2>
						<p class="mt-5">
							<b>Crea tu usuario Macal e inicia tu experiencia junto a nosotros:</b>
						</p>
						<p class="mb-5">
							<b-row>
								<b-col offset-md="1" class="text-justify">
									<b-row>
										<b-col>
											<ul class="macal-ul mt-3">
												<li>Indícanos qué auto o propiedad te gustaría comprar.</li>
												<li>Paga tu auto 100% online.</li>
											</ul>
										</b-col>
										<b-col>
											<ul class="macal-ul mt-3">
												<li>Realiza el seguimiento de tus compras y/o de tus ventas.</li>
												<li>Contrata servicios adicionales online, como créditos y seguros.</li>
											</ul>
										</b-col>
									</b-row>
								</b-col>
							</b-row>
						</p>
						<b-button v-if="!this.$store.state.isLogged" size="lg" class="pl-5 pr-5 mb-5" variant="outline-macal" to="/usuarios/login">Iniciar Sesión</b-button>
					</b-col>
				</b-row>
			</v-section-grey>
			<v-section-white specialClass="text-center">
				<b-row class="mt-5">
					<b-col>
						<p class="section-subheader pt-5 mb-5"><b>AHORA SOLO TE FALTA ELEGIR</b></p>
					</b-col>
				</b-row>
				<b-row class="text-center mb-5 d-md-none">
					<b-col cols="6" style="border-left: 1px solid #000000;">
						<b-img src="images/landing/icono-auto.png" fluid class="col-9"></b-img>
						<h4 class="mt-3">Autos</h4>
						<b-button block size="lg" class="mt-3" variant="outline-macal" to="/autos">Entrar</b-button>
					</b-col>
					<b-col cols="6">
						<b-img src="images/landing/icono-propiedades.png" fluid class="col-9"></b-img>
						<h4 class="mt-3">Propiedades</h4>
						<b-button block size="lg" class="mt-3" variant="outline-macal" href="https://www.macal.cl/Propiedades/Busqueda">Entrar</b-button>
					</b-col>
				</b-row>
				<b-row class="text-center mb-5 d-none d-md-flex">
					<b-col cols="4" offset="2">
						<b-img src="images/landing/icono-auto.png" fluid class="col-9"></b-img>
						<h3 class="mt-3">Autos</h3>
						<b-button size="lg" class="mt-3 pl-5 pr-5" variant="outline-macal" to="/autos">Entrar</b-button>
					</b-col>
					<b-col cols="4" style="border-left: 1px solid #000000;">
						<b-img src="images/landing/icono-propiedades.png" fluid class="col-9"></b-img>
						<h3 class="mt-3">Propiedades</h3>
						<b-button size="lg" class="mt-3 pl-5 pr-5" variant="outline-macal" href="https://www.macal.cl/Propiedades/Busqueda">Entrar</b-button>
					</b-col>
				</b-row>
			</v-section-white>
			<v-section-grey v-if="false">
				<b-row>
					<b-col class="text-center">
						<h2 class="pt-5"><b>ESTAS COMPAÑIAS CONFIAN EN <br />NOSOTROS</b></h2>
					</b-col>
				</b-row>
			</v-section-grey>
		</b-container>
		<v-advertising-modal>
		</v-advertising-modal>
	</div>
</template>

<script>
	import SectionHeader from "../components/section-header";
	import SectionWhite from "../components/section-white";
	import SectionGrey from "../components/section-grey";
	import AdvertisingModal from "../components/advertising-modal";

  export default {
	name: 'Index',
	components: {
		'v-section-header': SectionHeader,
		'v-section-white': SectionWhite,
		'v-section-grey': SectionGrey,
		'v-advertising-modal': AdvertisingModal
	},
	data() {
		return {
			video:{}
		}
	},
	beforeMount(){
		this.set_video()
	},
	mounted(){
		this.send_count();
	},
	methods: {
		scrollFromHead() {
			window.scroll({
				top: document.querySelector('.scroll-receiver').offsetTop - 150,
				behavior: 'smooth'
			});
		},
		send_count(){
			this.axios.post("meters", {id: 8, url: window.location.href, width: window.innerWidth, height: window.innerHeight}).then(() => {})
		},
		set_video(){
			this.axios.get("videos").then(result => {
				this.video = result.data
			})
		}
	}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
